// Initialize service worker for partial data caching.
if (navigator.serviceWorker) {
  window.addEventListener('load', () => {
    navigator.serviceWorker.register('/serviceworker.js').then(function(reg) {
      console.log('[Page] Service worker registered!')
    })
  })
}

// Import local time to show correct time value
import LocalTime from 'local-time'
LocalTime.start()

// Import matilda code
import '../../../vendor/matilda_core/scripts/main'

// Add custom controllers
import app from '../../../vendor/matilda_core/scripts/app'
import BackController from './controllers/BackController'
import WarningController from './controllers/WarningController'
import TippyController from './controllers/TippyController'
import LoginController from './controllers/LoginController'
app.register('back', BackController)
app.register('warning', WarningController)
app.register('tippy', TippyController)
app.register('login', LoginController)